import { BATTLEFIELD_CAPACITIES } from './gameConfig.js'
import { rules } from './config.js'

export const blankGameBoard = (capacities = BATTLEFIELD_CAPACITIES, { firstAttackRound = rules().firstAttackRound } = {}) => {
    return capacities.map((maxArmyQty, index) => ({
        id: index + 1,
        maxArmyQty,
        armyQty: 0,
        newArmies: 0,
        movedInArmies: 0,
        movedFrom: null,
        movedOut: false,
        isAttacking: false,
        // Rounds still to pass before this corridor may attack (canAttack);
        // matureCorridor counts it down. Boards saved without it never wait.
        attackHold: Math.max(0, firstAttackRound - 1),
        fortInConstruction: 0,
        fortCount: 0,
        // Per-Base ledger: [{ centerS, progress, mature }] — any number of
        // Bases per corridor, each with its own Grid position and maturation
        // clock. Bases live on the Grid, not in slots. pendingBaseBuilds
        // holds this round's undoable builds ({ funded, centerS }).
        bases: [],
        pendingBaseBuilds: null,
        fortMovedInFunded: 0,
        // Positional render model: slots[plot] = null | unit token (see
        // gameLogic.js "Corridor slots"). Front plot = index 0.
        slots: Array(maxArmyQty).fill(null),
        nextUid: 1,
    }))
}
